export default "__VITE_ASSET__AFkv9PzT__ 320w, __VITE_ASSET__BBRZwHra__ 640w";